<div class="error-page primary-area h-fluid w-fluid" *transloco="let t, read: 'page.server-error'">
  <div class="error-page-message">
    <img src="/assets/web_development.svg" alt="Card payment" class="m_b-8"/>
    <h3 class="m_b-3">{{t('server-error')}}</h3>
    <div class="body_text text-center centered_text">{{t('error-description.prefix')}}<br>{{t('error-description.suffix')}}</div>
  </div>
</div>